import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';

interface ISectionProps {
  children?: ReactNode;
  className?: string;
  afterHeaderCardRow?: boolean;
  noContentBorder?: boolean;
}

const PADDING_BOTTOM = theme.space['3xl'];

const Layout = styled.section<ISectionProps>`
  position: relative;
  z-index: ${theme.zIndex.content};
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: auto;
  padding: 0 0 ${toRem(PADDING_BOTTOM)} ${toRem(theme.space.xl)};

  @media (min-width: ${theme.breakpoint.small}px) {
    padding: 0 0 ${toRem(PADDING_BOTTOM)} ${toRem(theme.space['3xl'])};
  }

  &:last-child {
    margin-bottom: 0;
    padding-bottom: 0;

    > div {
      margin-bottom: 0;
      padding-bottom: 0;
      border-bottom: none;
    }
  }

  ${({ afterHeaderCardRow }) =>
    afterHeaderCardRow &&
    css`
      z-index: ${theme.zIndex.contentHeader + 50};
    `}
`;

const Content = styled.div<ISectionProps>`
  position: relative;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: auto;
  padding: 0 ${toRem(theme.space.xl)} ${toRem(PADDING_BOTTOM)} 0;
  border-bottom: ${toRem(1)} solid ${theme.color.neutral[200]};

  @media (min-width: ${theme.breakpoint.small}px) {
    padding: 0 ${toRem(theme.space['3xl'])} ${toRem(PADDING_BOTTOM)} 0;
  }

  ${({ noContentBorder }) =>
    noContentBorder &&
    css`
      border-bottom: 0;
    `}
`;

const Section = ({ children, className, afterHeaderCardRow, noContentBorder, ...rest }: ISectionProps) => (
  <Layout afterHeaderCardRow={afterHeaderCardRow} className={className} {...rest}>
    <Content noContentBorder={noContentBorder}>{children}</Content>
  </Layout>
);
export default Section;
